import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_drpw6ajrkv: FaireBrandEntity = {
  token: "b_drpw6ajrkv",
  type: "brand",
  name: "Recess",
  avatarUrl:
    "https://cdn.faire.com/fastly/7061857c36e165fcc5afdecace9081a142b60049b9089955059a309a345d6e13.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/88a4212f6c38b8f4de95608ae1197316129365f5ee5db72f0dc7d065bb268920.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7061857c36e165fcc5afdecace9081a142b60049b9089955059a309a345d6e13.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/88a4212f6c38b8f4de95608ae1197316129365f5ee5db72f0dc7d065bb268920.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 23,
  isInsider: true,
  description:
    "who is Recess? we’re a team of creative people in search of calm. Recess helps people feel calm, focused and creative despite the stressful world around them. a couple of years ago, we created our first product line and canned a feeling. now we make a variety of products that all help you feel calm cool collected in different ways. we all have too many tabs open in our browsers & our brains. that’s why we made Recess: to help you relax & unwind.\n\nRecess Zero Proof: craft mocktails for alcohol-free moments. tastes & feels like your favorite cocktails without the consequences\n\nRecess Mood: sparkling water infused with magnesium & adaptogens to help you unwind\n\nRecess Mood Powder: 3-in-1 powder blend with magnesium, adaptogens & electrolytes, so you can add some calm to whatever you’re drinking\n\nRecess: sparkling water infused with hemp & adaptogens for calm & clarity",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:40.779Z",
    importedBy: "entity-db-cli",
  },
};
